<template>
  <div>
    <div v-if="loading">
      <az-loading />
    </div>

    <div v-else>
      <template v-if="paciente">
        <ficha-paciente :paciente="paciente" :panel="panel" @atualizado="reload_pac()" />
        <historico-pacotes-paciente ref="histpacote" />
        <lembrete-paciente v-model="paciente" ref="lembrete_pac_perfil" />
      </template>

      <div class="card dashcard">
        <div class="card-body d-flex justify-content-between">
          <div>
            <celula-dados-procedimento :hor="{ marcacao: marcacao }" @abriranexos="$refs.anexo.abrir_anexar_arquivo(marcacao)" />
            <div>#{{ marcacao.id_atendimento }}</div>
          </div>
          <div>
            <!-- Lembrete -->
            <button id="botao-lembrete-perfil" v-if="paciente" type="button" class="btn btn-outline-secondary" data-toggle="tooltip" data-placement="top" 
              title="Lembrete relacionado ao paciente." @click="$refs.lembrete_pac_perfil.editar()">
              <i class="fas fa-thumbtack fa-fw"></i>
            </button>

            <!-- Arquivos -->
            <button id="botao-solic-consumo" v-if="paciente && tem_anamnese(marcacao)" type="button" class="btn btn-outline-danger ml-1" data-toggle="tooltip" data-placement="top" title="Anexar Arquivos." 
              @click="$refs.anexo.abrir_anexar_arquivo(marcacao.atendimento.atendimento_procedimentos[0].anamnese, 'anamnese', 'id_anamnese')">
              <i class="fa-solid fa-paperclip"></i>
              <span class="badge badge-danger ml-1" v-if="marcacao.atendimento.atendimento_procedimentos[0].anamnese.arquivos.length">
                {{ marcacao.atendimento.atendimento_procedimentos[0].anamnese.arquivos.length }}
              </span>
            </button>

            <!-- Solicitação para Consumo de Paciente -->
            <button id="botao-solic-consumo" v-if="paciente" type="button" class="btn btn-outline-secondary ml-1" data-toggle="tooltip" data-placement="top" title="Solicitação para consumo de paciente." @click="solic_consumo()">
              <i class="fa-solid fa-boxes-packing fa-fw"></i>
            </button>

            <!-- Amostras -->
            <button class="btn btn-outline-primary ml-1" type="button" @click="verColeta (marcacao)" v-if="marcacao && marcacao.atendimento" data-toggle="tooltip" data-placement="top" title="Ver Amostras">
                <i class="fa-solid fa-vial"></i>
            </button>

            <!-- Lembrete -->
            <button type="button" class="btn btn-outline-secondary ml-1" data-toggle="tooltip" data-placement="top" title="Lembrete relacionado ao paciente." @click="$refs.lembrete_pac_perfil.editar()">
              <i class="fas fa-thumbtack mr-2"></i>
              <i class="fas fa-user-injured"></i>
            </button>

            <!-- Alergias -->
            <button type="button" class="btn btn-outline-danger ml-1" data-toggle="tooltip" data-placement="top" title="Alergias" @click="abrir_alergias()">
              <i class="fa-solid fa-droplet-slash"></i>
            </button>

            <!-- Lançamentos -->
            <button id="botao-lancamento" v-if="paciente" type="button" class="btn btn-outline-primary ml-1" data-toggle="tooltip" data-placement="top" 
              title="Lançamentos." @click="addProcedimento()">
              <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      <pre class="alert alert-warning" v-if="false">{{ marcacao }}</pre>
      <pre class="alert alert-warning" v-if="false">{{ marcacao.item_status }}</pre>

      <!-- Resultados -->
      <button class="btn btn-outline-success" type="button" @click="ver_resultados ()" v-if="resultados && resultados.length"
        id="pep-ver-resultados"
        data-toggle="tooltip"
        data-placement="top"
        title="Tabela de Resultados de Exames">
        <i class="fa fa-table" aria-hidden="true"></i>
      </button>

      <div class="d-flex flex-column mb-3" v-if="marcacao_pra_chamar">
        <div class="form-row">
          <div class="col col-12 col-md-4 d-flex flex-column">
            <button 
              id="pep-chamar-novamente"
              type="button"
              class="btn btn-outline-danger"
              :disabled="rechamado"
              @click="chamarNovamente()">
              <i class="fas fa-bell mr-2" v-if="!$store.state.loading"></i>
              <div class="spinner-border spinner-border-sm" role="status" v-else>
                <span class="sr-only">Loading...</span>
              </div>
              Chamar Novamente
            </button>
          </div>
          <div class="col col-12 col-md-4 d-flex flex-column">
            <button 
              v-if="marcacao_pra_chamar"
              type="button"
              class="btn btn-outline-success"
              id="pep-iniciar-atendimento"
              @click="iniciarAtendimento()">
              <i class="fas fa-play mr-2" v-if="!$store.state.loading"></i>
              <div class="spinner-border spinner-border-sm" role="status" v-else>
                <span class="sr-only">Loading...</span>
              </div>
              Iniciar Atendimento
            </button>
          </div>
          <div class="col col-12 col-md-4 d-flex flex-column">
            <button 
              v-if="marcacao_pra_chamar"
              type="button"
              class="btn btn-outline-secondary"
              id="pep-nao-iniciar-atendimento"
              @click="naoComparecer(marcacao_pra_chamar)">
              <i class="fas fa-times mr-2" v-if="!$store.state.loading"></i>
              <div class="spinner-border spinner-border-sm" role="status" v-else>
                <span class="sr-only">Loading...</span>
              </div>
              Paciente não compareceu
            </button>
          </div>
        </div>
      </div>

      <!-- Paciente atendido na recepção, aguardando ser chamado -->
      <span v-if="false && marcacao.item_status.valor == 'atendido'" class="d-flex align-items-center">
        <i class="far fa-bell fa-3x mr-3 text-success" data-toggle="tooltip" data-placement="top" title="Atendimento realizado na recepção"></i>
        <button 
          type="button" 
          class="btn btn-outline-success mr-2" 
          :disabled="$store.state.loading || marcacao.id_medico != $store.state.user.id_pessoa" 
          @click="chamar(marcacao)">
          Chamar Paciente
        </button>
      </span>

      <template v-if="!marcacao_pra_chamar">

        <div class="mb-3" v-if="marcacao.arquivos && marcacao.arquivos.length">
          <az-sub-title class="mt-3" title="Anexos do Atendimento" />
          <a :href="arq.arquivo.temporary_url" class="text-white"
            v-for="(arq, iax) in marcacao.arquivos" :key="iax" target="_blank">
            <span class="badge badge-primary p-2 mr-2 mb-2">
              <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
              {{ arq.arquivo.st_titulo }}  
            </span>
          </a>
        </div>

        <!-- Registrar Documento -->
        <div class="d-flex flex-column">
          <button type="button" class="btn btn-primary" @click="$refs.doc_pre_atend.abrir(marcacao)">
            Formulário
            <span class="badge badge-light ml-2" v-if="marcacao.doc_pre_atends && marcacao.doc_pre_atends.length">
                {{ marcacao.doc_pre_atends.length }}
            </span>
          </button>
        </div>

        <!-- Lista de Laudos -->
        <div class="mt-3" v-if="lista_laudos.length">
            <p class="mb-1">Exames</p>
            <ul class="list-group">
                <li class="list-group-item" v-for="(atp, ilx) in lista_laudos" :key="ilx">
                    <a href="#" class="card-link" @click.prevent="abrir_laudo(atp)">
                        {{ atp.procedimento.search }}
                    </a>
                </li>
            </ul>
        </div>

        <!-- Menu de Opções -->

        <nav class="navbar fixed-bottom navbar-light bg-light">
          <a class="navbar-brand" href="#" @click.prevent>
            &nbsp;
          </a>
          <div class="mr-3">
            <!-- Finalizar Atendimento -->
            <button type="button" class="btn btn-danger btn-sm" 
              @click="selecionarFinalizar()"
              v-if="marcacao_pra_finalizar">
              <span class="d-block d-lg-none">
                <i class="fas fa-power-off"></i>
              </span>
              <span class="d-none d-lg-block">
                <i class="fa-solid fa-stop mr-2"></i> 
                Finalizar
              </span>
            </button>
          </div>
        </nav>

      </template>

      <!-- Pré Atendimento -->  
      <div class="mt-3">
        <pre-atendimento-view :marcacao="marcacao" v-if="atendimento" :aberto="true" :tem_ass="true" @refresh="load()" />
      </div>

    </div>

    <!-- Resultados -->
    <resultados ref="resultados" name="pep" block="1" />

    <!-- Galeria de Imagems -->
    <gallery-preview ref="galleryperfil" :emmodal="true" />

    <!-- Visualização de Documentos -->
    <div class="modal fade" id="docViewModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content" v-if="doc">
          <div class="modal-header">
            <h5 class="modal-title">{{ doc.st_titulo }}</h5>
              <button type="button" class="close" @click="fechar_modal('docViewModal')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <doc-view :view="true" :doc="doc" />
          </div>
          <div class="modal-footer" v-if="doc">
            <az-submit @click="$util.print_preview('imprimir/documento/' + doc.id_documento_atendimento, true)">Imprimir</az-submit>
            <button type="button" class="btn btn-secondary" @click="fechar_modal('docViewModal')">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Registro Avulso -->
    <div class="modal fade" id="registroAvulsoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content" v-if="procedimentos_avulso">
          <div class="modal-header">
            <h5 class="modal-title">Selecione o Procedimento</h5>
              <button type="button" class="close" @click="fechar_modal_avulso()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <az-input
              class="mb-2"
              icon="fa fa-search"
              v-model="search_avulso" />

            <div class="list-group">
              <button type="button" class="list-group-item list-group-item-action" v-for="(proc, ipx) in lista_procedimentos_avulsos" :key="ipx"
                @click="salvar_avulso(proc)" :disabled="incluindo_avulso">
                {{ proc.search }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pré Atendimento -->
    <documento-pre-atendimento ref="doc_pre_atend" @refresh="load()" />

    <template v-if="marcacao">
      <marcacao-estoque-solicitacoes :marcacao="marcacao" />
    </template>

    <template v-if="marcacao && marcacao.outras">

      <div v-for="(outra, iox) in marcacao.outras" :key="iox">
        <az-input
          type="checkbox-group"
          :label="outra.procedimento.search" 
          v-model="outra.fila">
          <template v-slot:buttonposcb>
            <div class="input-group-append">
              <span class="input-group-text" id="basic-addon2">{{ outra.item_status.quebra }}</span>
            </div>
          </template>
        </az-input>
      </div>

    </template>

    <br><br><br><br><br>

    <pre class="alert alert-warning mt-3" v-if="false">{{ marcacao }}</pre>

    <!-- Finalizar Pré-Atendimento -->
    <!-- Modal de Finalização de Atenimdento -->
    <div
      class="modal fade"
      id="finalizarAtendimentoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered2" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Finalizar</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-info">{{ titulo_fila ? titulo_fila : 'Pré-Atendimento' }}</div>
            <h4>Confirma finalizar o atendimento?</h4>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <az-submit @click="finalizar ()">Confirmar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Inclusão de Procediemntos -->
    <div class="modal fade" id="addProcedimentoPreModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Adicionar Procedimento</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="marcacao && novoProcedimento">
            <procedimentos
              ref="proced"
              :idMarcacao="marcacao.id_marcacao"
              :consultorio="true"
              :assistencia="true"
              :validate="validate"
              :posUpdate="procedimentosIncluidos"
            />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="incluirProcedimento ()">Atualizar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <anexar-marcacao-documentos ref="anexo" />
    <alergia ref="alergia" @refresh="load()" />
    <amostras ref="amostras" />

  </div>
</template>

<script>
import _ from "lodash";
import * as moment from "moment";
import $ from "jquery";
import FichaPaciente from "../../shared/FichaPaciente.vue";
//import Formulario from "../consultorio/Formulario.vue";
import AzSubmit from '../../util/AzSubmit.vue';
import LembretePaciente from "../consultorio/LembretePaciente.vue";
//import IniciarAtendimento from "../recepcao/IniciarAtendimento.vue";
import AzLoading from '../../util/AzLoading.vue';
import Resultados from '../consultorio/Resultados.vue';
import PreAtendimentoView from '../consultorio/PreAtendimentoView.vue';
import GalleryPreview from '../../shared/gallery/GalleryPreview.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import HistoricoPacotesPaciente from '../../shared/HistoricoPacotesPaciente.vue';
import DocView from '../consultorio/DocView.vue';
import CelulaDadosProcedimento from '../../shared/table/CelulaDadosProcedimento.vue';
import DocumentoPreAtendimento from '../../shared/DocumentoPreAtendimento.vue';
import AnexarMarcacaoDocumentos from '../recepcao/AnexarMarcacaoDocumentos.vue';
import Procedimentos from "../recepcao/Procedimentos.vue";
import AzSubTitle from '../../util/AzSubTitle.vue';
import MarcacaoEstoqueSolicitacoes from './MarcacaoEstoqueSolicitacoes.vue';
import Alergia from '../consultorio/Alergia.vue';
import Amostras from '../laboratorio/Amostras.vue';

export default {
  data() {
    return {
      tamanho: 'M',
      paciente: {},
      atendimentos: [],
      atendimento: {},
      marcacao: null, 
      marcacoes: null,
      nome: "",
      loading: true,
      search: "",
      lista: null,
      search_timeout: null,
      cancelar: false,
      pode_atender: false,
      atender: false, 
      local: "", 
      legado: [],
      lista_legado: [],
      rechamado: false,
      resultados: [], 
      id_anexar_prontuario_legado: null, 
      incluindo_avulso: false, 
      expandido: true, 
      procedimentos_avulso: null,
      search_avulso: "", 
      doc: null, 
      listMode: 'L',
      anexo: { 
        model: "",
        id: -1,
        arquivos: [], 
      },
      novoProcedimento: false, 
      titulo_fila: null, 
    };
  },
  props: ["id", "tmp", "panel", "fila"],
  components: {
    FichaPaciente,
    LembretePaciente,
    AzLoading,
    Resultados,
    GalleryPreview, 
    AzInput, 
    HistoricoPacotesPaciente,
    DocView, 
    AzSubmit, 
    CelulaDadosProcedimento,
    DocumentoPreAtendimento,
    PreAtendimentoView,
    AnexarMarcacaoDocumentos,
    AzSubTitle,
    Procedimentos,
    MarcacaoEstoqueSolicitacoes, 
    Alergia, 
    Amostras
  },

  computed: {
    lista_laudos: function () { 
      if ( !this.marcacao || !this.marcacao.atendimento )
        return [];

      return this.marcacao.atendimento.atendimento_procedimentos.filter(item => item.laudo)
    },

    cookie_list_mode: function () { 
      return 'pep-list-mode-' + this.$store.state.user.id_usuario;
    },

    na_recepcao: function() { 
      return this.$route.path == '/recepcao';
    },

    telefones: function() {
      return !this.paciente.cadastro
        ? []
        : this.paciente.cadastro.telefone_cadastros.filter(item => {
            return item.telefone.st_numero.trim();
          });
    },

    marcacao_pra_chamar: function() {
      if ( !this.marcacao )
        return;

      return this.marcacao.dt_inicio.substr(0,10) == this.$util.hoje() 
          && this.marcacao.item_status 
          && ( this.marcacao.item_status.valor == 'chamado-pre' || this.marcacao.item_status.valor == 'nao-compareceu' );
    },

    marcacao_pra_finalizar: function() { 
      if ( !this.marcacao )
        return;

      return ( 
            this.marcacao.dt_inicio.substr(0,10) != this.$util.hoje() 
            && this.marcacao.item_status 
            && ( this.marcacao.item_status.valor == 'chamado-pre' || this.marcacao.item_status.valor == 'nao-compareceu' ) )
          || ( 
            this.marcacao.item_status 
            && ( this.marcacao.item_status.valor == 'em pre-atendimento' )
          );
    },

    lista_procedimentos_avulsos: function() { 
      if ( !this.procedimentos_avulso )
        return [];

      let pesquisar = this.search_avulso.trim();
      let parts = pesquisar.replace(' ','.*');
      let match = parts;
      let reg = new RegExp(match, 'i');

      return this.procedimentos_avulso && this.procedimentos_avulso.length ? 
          this.procedimentos_avulso.filter (item => { 
              return ( !this.search_avulso || reg.test(JSON.stringify(item)) );
          }) : null;
    }

    
  },
  methods: {
    verColeta (item) { 
        this.$refs.amostras.abrir(item.id_atendimento, false, "");
    },

    abrir_alergias () { 
      $('[data-toggle="tooltip"]').tooltip("dispose");
      this.$refs.alergia.abrir(this.marcacao.id_paciente);
    },

    tem_anamnese (marcacao) { 
      return _.get(marcacao, 'atendimento.atendimento_procedimentos.0.anamnese');
    },

    solic_consumo(id_estoque_solicitacao = null) { 

      let solicgeral = this.$util.get_solic_geral();

      if ( solicgeral ) { 
        /*
          if ( this.atendimento && this.atendimento.marcacao && this.atendimento.paciente ) { 
            this.atendimento.marcacao.nome_paciente = this.atendimento.paciente.st_nome;
          }
        */
          
        solicgeral.solicitar(
            'S', 
            { 
                id_estoque_solicitacao: id_estoque_solicitacao, 
                marcacao: this.marcacao 
            },
            () => { 
                this.load();
            }
        );

      }

    },

    addProcedimento() {
      this.novoProcedimento = false;

      this.$nextTick(() => {

        this.novoProcedimento = true;

        this.$nextTick(() => {
          this.$refs.proced.carregar();
          $("#addProcedimentoPreModal").modal("show");
        });

      });
    },

    incluirProcedimento() {
      if (this.$refs.proced.temItemBloqueado()) {
        alert("Item sem cobertura pela operadora.");
        return;
      }

      this.$store.commit("loading", true);

      this.$refs.proced
        .atualizar()
        .then(res => {
          if (res && res.data.retorno.status == 200) {
            this.$util
              .loadItem(this, {
                service: "atendimentos",
                func: "iniciar",
                id: this.marcacao.id_atendimento
              })
              .then(res => {
                if (res) {
                  this.load();
                  $("#addProcedimentoPreModal").modal("hide");
                }
              });
          } else if (res && res.data.retorno.status == 290) {
            this.load();
            $("#addProcedimentoPreModal").modal("hide");
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });

    },

    procedimentosIncluidos() {
      alert("procedimentosIncluidos");
    },

    abrir_laudo (atp) { 
      const lista = this.lista_laudos.map(item => { 
          return { 
              id_laudo: item.laudo.id_laudo,
              id_fila: null, 
              id_paciente: this.paciente.id_paciente,
              nome_paciente: this.paciente.st_nome,
              nome_medico: this.marcacao.medico.search,
              nome_procedimento: item.procedimento.search,
              dt_inclusao: null, 
              status_laudo: null,
              titulo_fila: null,
          };
      });

      const params = { 
          id: atp.laudo.id_laudo,
          fila: null, 
          lista: lista, 
          filtro: {}, 
          voltar: this.$route.path, 
      };

      this.$router.push({
          name: 'laudo', 
          params: params, 
      });
    },

    agrupar_procedimentos(marcacao) { 
      let lista = _.map(
            _.groupBy(marcacao.atendimento.atendimento_procedimentos, 'id_procedimento'),
            (itens) => { 
              return { 
                qtd: _.sumBy(itens, 'in_quantidade'),
                proc: _.first(itens).procedimento.search, 
              };
            }
          );

      lista = _.orderBy(lista, 'proc');

      return lista;
    },
    imprimirAnamnese(id_anamnese) {
      this.$util.print_preview('imprimir/anamnese/' + id_anamnese, true);
    },
        
    toggle_modo_view () { 
      $('[data-toggle="tooltip"]').tooltip("dispose");
      this.listMode = this.listMode == 'S' ? 'L' : 'S';
      this.$util.setCookie(this.cookie_list_mode, this.listMode);
    },

    definir_tamanho_fonte (tamanho) { 
      this.tamanho = tamanho;
      this.$util.setCookie('tamanho-fonte-pep', this.tamanho);
    },

    abrirAtendimentoNaRecepcao (marcacao) { 
      $('.modal').modal('hide');
      this.$root.$children[0].$refs.modulo.iniciar(marcacao, 1);
    },

    abrir_galeria_imagens() { 
      this.$refs.galleryperfil.abrir({ id_paciente: this.id });
    },

    tem_receita (marcacao) { 
      return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.receita && item.anamnese.receita.length) ? true : false;
    },

    tem_requisicao (marcacao) { 
      return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.requisicao && item.anamnese.requisicao.length) ? true : false;
    },

    tem_arquivo (marcacao) { 
      return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.arquivos && item.anamnese.arquivos.length) ? true : false;
    },

    tem_atestado (marcacao) { 
      return marcacao.atendimento.atendimento_procedimentos.find(item => item.anamnese && item.anamnese.atestados && item.anamnese.atestados.length) ? true : false;
    },

    selecionarFinalizar() {
      $("#finalizarAtendimentoModal").modal("show");
    },

    finalizar() {
      this.$store.commit("loading", true);

      let query = {
        q: [
          {
            name: "atendimentos.finalizar",
            id: "iniciar",
            parms: {
              id: this.marcacao.id_atendimento,
              outras: this.marcacao.outras 
                ? this.marcacao.outras.filter(item => item.fila && item.id_atendimento)
                    .map(item => item.id_atendimento)
                : [],
              pre_atend: true, 
              fila: this.fila, 
            }
          }
        ]
      };

      this.axios
        .post("/aql", query)
        .then(res => {
          if (res.data.iniciar.status == 200) {
            if (res.data.iniciar.data.id_etapa_atendimento == 13) {
              this.$store.commit("loading", false);
              $("#finalizarAtendimentoModal").modal("hide");
              this.ir_para_lista();
            }
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });
    },

    ir_para_lista() { 
      this.$router.push({ path: "/assistencia/atend" });
    },

    tour() { 
      window.scrollTo(0,0);

      // Define the tour!
      var tour = {
          id: "hello-hopscotch",
          i18n: { 
                  doneBtn: "Pronto",
                  nextBtn: "Próximo",
                  prevBtn: "Anterior",
                  skipBtn: "Pular"
              },
          steps: [
              {
                  title: "Pesquisar",
                  content: "Utilize esse campo para realizar pesquisas por palavra chave no histórico do paciente. É possível buscar pelo nome do procedimento, especialidade, nome de medicamento ou qualquer palavra que esteja presente no histórico.",
                  target: "pep-pesquisa",
                  placement: "bottom"
              },
              {
                  title: "Lembrete",
                  content: "Registro de lembrete vinculado ao paciente. Exibido na recepção e no consultório.",
                  target: "botao-lembrete-perfil",
                  placement: "left"
              },
              {
                  title: "Galeria de Imagens",
                  content: "Galeria de imagens do paciente. Permite visualização e comparação de imagens.",
                  target: "botao-galeria-de-imagens-perfil",
                  placement: "left"
              },
              {
                  title: "Resultados",
                  content: "Utilize esse botão para visualizar a planilha de histórico de resultados do paciente.",
                  target: "pep-ver-resultados",
                  placement: "left"
              },
              {
                  title: "Registro Avulso",
                  content: "Inclusão de atendimento avulso para o paciente.",
                  target: "pep-novo-atendimento",
                  placement: "left"
              },
              {
                  title: "Visualização",
                  content: "Este botão deve ser utilizado para definir se a visualização do histórico será detalhada, ou apenas da lista de atendimentos.",
                  target: "pep-detalhes",
                  placement: "left"
              },
              {
                  title: "Chamar Novamente",
                  content: "Ao clicar nesse botão, o aviso da chamada será enviada novamente para o painel de chamada.",
                  target: "pep-chamar-novamente",
                  placement: "bottom"
              },
              {
                  title: "Iniciar Atendimento",
                  content: "Ao clicar nesse botão, o atendimento do paciente será iniciado.",
                  target: "pep-iniciar-atendimento",
                  placement: "bottom"
              },

          ]
      };

      window.hopscotch.startTour(tour);

    },

    tem_doc_certificado(atendimento) {

      if ( !atendimento )
        return false;

      if ( atendimento.atendimento_procedimentos.findIndex(atp => {

        if ( atp.anamnese ) { 

          if ( atp.anamnese.receita.findIndex(item => {
            return !!item.doc_certificado;
          }) >= 0 ) { 
            return true;
          } 

          if ( atp.anamnese.requisicao.findIndex(item => {
            return !!item.doc_certificado;
          }) >= 0 ) { 
            return true;
          } 

        }

        return false;
        
      }) >= 0 ) { 
        return true;
      }

      return false;

    },

    compartilhar(atendimento) { 
      this.$refs.compartilhardocs.compartilhar(atendimento.id_atendimento);
    },

    toggle_expandir() { 
      $('[data-toggle="tooltip"]').tooltip("dispose");
      this.$util.setCookie('pep-comprimido', this.expandido);
      this.expandido = !this.expandido;
      $('.collapse-pep').collapse(this.expandido ? 'show' : 'hide');
    },

    abrir_doc_view(doc) { 
      this.doc = doc;
      $('#docViewModal').modal('show');
    },

    fechar_modal_avulso() { 
      $('#registroAvulsoModal').modal('hide');
    },

    fechar_modal(modal) { 
      $('#' + modal).modal('hide');
    },

    salvar_avulso(proc) {

      this.incluindo_avulso = true;

      this.$util.atualizar(this, { 
        service: 'pep',
        func: 'incluir_avulso',
        dados: { 
          id_paciente: this.id,
          id_procedimento: proc ? proc.id_procedimento: null, 
        },
        callback: res => { 
          this.incluindo_avulso = false;
          $(".modal").modal("hide");

          if ( this.$route.path.substr(0,17) == '/consultorio/res/' ) { 
            this.$router.push({ name: "redir", params: { path: "/consultorio/res/" + res.id_atendimento } });
          } else { 
            this.$router.push({ path: "/consultorio/res/" + res.id_atendimento });
          }
        },
        final: () => { 
          this.incluindo_avulso = false;
        }
      });

    },

    novo_atendimento_avulso() { 
      this.incluindo_avulso = true;

      $('[data-toggle="tooltip"]').tooltip("dispose");

      this.$util.loadItem(this, { 
        service: 'medico_procedimento_unidades',
        func: 'index',
        parms: { 
          id_medico: this.$store.state.user.id_pessoa, 
          avulso: true, 
        }
      })
      .then(res => { 
        this.procedimentos_avulso = res;

        if ( res.length ) { 

          this.procedimentos_avulso.unshift({
            id_procedimento: 1177,
            search: "REGISTRO AVULSO",
          });

          this.$nextTick(() => { 
            $('#registroAvulsoModal').modal('show');
          });
        } else { 
          this.salvar_avulso();
        }
      })
      .finally(() => { 
        this.incluindo_avulso = false;
      });

    },

    enviar_arquivo(pl, model, chave) {

      this.anexo.model = model;
      this.anexo.id = _.get(pl, chave);
      this.anexo.arquivos = _.get(pl, 'arquivos');

      if ( !this.anexo.id ) { 
        alert('Chave não identificada (' + chave + ').');
        return;
      }

      // this.id_anexar_prontuario_legado = pl.id_prontuario_legado;

      this.$nextTick(() => { 
        this.$refs.upload_pl.abrir();
      });
    },

    remover_anexo(anexo) { 
      this.$util.atualizar(this, { 
        service: 'arquivos',
        func: 'destroy',
        dados: { 
            id: anexo.id_arquivo_link, 
        },
        callback: this.refresh_arquivos,
      })
    },

    refresh_arquivos () { 
      this.id_anexar_prontuario_legado = null;
      this.load();
    },

    ver_resultados () { 
      this.$refs.resultados.visuaizar(this.id);
    },

    chamarNovamente () { 
      this.rechamado = true;
      this.chamar(this.marcacao);
    },

    chamar (marcacao) { 

      this.$store.commit('loading', true);

      let query = { q: [
        { 
          name: "atendimentos.chamar",
          id: "chamada",
          parms: { 
            id: marcacao.atendimento.id_atendimento, 
            id_recepcao: this.$util.getCookie('id_unidade_operacao') ? this.$util.getCookie('id_recepcao') : null,
            local: this.local,
            block_painel: this.$util.getCookie('nao-enviar-painel'),  
            pre_atend: true, 
          }
        }
      ]};

      this.axios.post('/aql?a=ratendimentos.chamar', query)
        .then(res => { 
          if ( res.data.chamada.status == 200 ) { 
            marcacao.item_status.ultima_etapa = res.data.chamada.data.etapa_atendimento;
            this.$store.commit('loading', false);

            const msg = res.data.chamada.data.msg ? res.data.chamada.data.msg.msg : "Chamada re-enviada.";
            const severity = res.data.chamada.data.msg && res.data.chamada.data.msg.status_code > 400 ? 'warn' : 'success';

            if ( this.rechamado ) { 
              this.$toast.add({
                severity: severity,
                summary: "Chamar",
                detail: msg,
                life: 3000
              });
            } else { 
              this.load(false);
            }
          }
        })
        .finally (() => { 
          this.$store.commit('loading', false);
        });

    },

    registrarAtendimento(item) { 

      this.$store.commit("loading", true);
      this.atender = true;

      this.$nextTick(() => { 

        let query = {
          q: [
            {
              name: "marcacoes.show",
              id: "item",
              parms: {
                id: item.id_marcacao,
                para_atendimento: true
              }
            }
          ]
        };
  
        this.axios
          .post("/aql", query)
          .then(res => {
            if (res.data.item.status == 200) {
              let marcacao = res.data.item.data;
              $('.modal').modal("hide");
              $('[data-toggle="tooltip"]').tooltip("dispose");
              this.$refs.ini_atd_consultorio.abrir(marcacao, 1);
            }
          })
          .finally(() => {
            this.$store.commit("loading", false);
          });

      });

    },

    cancelar_marcacao(marcacao) {
      this.cancelar = true;

      this.$nextTick(() => {
        this.$refs.canc_atd_pep.cancelar(marcacao);
      });
    },

    editar_marcacao(marcacao) { 
      this.$root.editar_marcacao(marcacao.id_marcacao);
    },

    pesquisar() {
      this.$store.commit("loading", true);

      if (this.search_timeout) clearTimeout(this.search_timeout);

      this.search_timeout = setTimeout(() => {
        this.filtrar();
        this.search_timeout = null;
      }, 300);
    },
    filtrar() {
      let pesquisar = this.search.trim();
      let parts = pesquisar.replace(" ", ".*");
      /*let match = parts.reduce((total, item) => {
            return total + `.*${item}.*`;
        }, "" );*/
      let match = parts;
      let reg = new RegExp(match, "i");
      let items;
      let legado; 

      if (pesquisar) {
        items = this.marcacoes.filter(item => {
          return reg.test(JSON.stringify(item));
        });

        legado = this.legado.filter(item => {
          return reg.test(JSON.stringify(item));
        }); 
      } else {
        items = this.marcacoes;
        legado = this.legado ? this.legado : [];
      }

      this.lista = _.cloneDeep(items);
      this.lista_legado = _.cloneDeep(legado);

      this.$store.commit("loading", false);

    },
    retornarAoAtendimento(atd) {
      $(".modal").modal("hide");

      if ( this.$route.meta.enfermagem ) { 
        this.$router.push({ path: "/assistencia/atendimento/" + atd.id_atendimento + '/' + this.fila});
      } else { 

        if ( this.$route.path.substr(0,17) == '/consultorio/res/' ) { 
          this.$router.push({ name: "redir", params: { path: "/consultorio/res/" + atd.id_atendimento } });
        } else { 
          this.$router.push({ path: "/consultorio/res/" + atd.id_atendimento });
        }

        //this.$router.push({ path: "/consultorio/res/" + atd.id_atendimento });
      }
    },
    naoComparecer(atd) { 
      if ( !confirm('Confirma registrar o não comparecimento do paciente a chamada?') ) 
        return;

      this.$util.atualizar(this, { 
        service: 'atendimentos',
        func: 'pausar',
        dados: { 
          id: atd.id_atendimento, 
          nao_compareceu: true, 
        },
        callback: () => { 
          this.$router.push({ name: "consultorio" });
        }
      });

    },

    iniciarAtendimento() {
      this.$store.commit("loading", true);

      let query = {
        q: [
          {
            name: "atendimentos.iniciar",
            id: "iniciar",
            parms: { 
              id: this.marcacao.id_atendimento,
              pre_atend: true,
              fila: this.fila
            }
          }
        ]
      };

      this.axios
        .post("/aql", query)
        .then(res => {
          if (res.data.iniciar.status == 200) {
            if (res.data.iniciar.data.id_etapa_atendimento == 12) {
              this.load();
            }
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });
    },
    reload_pac() { 

      let query = {
        q: [
          {
            name: "pacientes.show",
            id: "paciente",
            parms: { id: this.$props.id, with: ["atendimentoPacotes", "logo.arquivo"] }
          }
        ]
      };

      this.axios
        .post("/aql?a=rpacientes.show", query)
        .then(res => {
          this.paciente = res.data.paciente.data;
          
          if (!this.panel) {

            this.$store.commit("setBreadcrumb", [
            { name: "Assistência", path: "/assistencia/atend" },
            { name: 'Pré-Atendimento: ' + this.paciente.st_nome, path: this.$route.path }
            ]);
            
          }
        });

    },
    load() {
      this.$store.commit("loading", true);
      this.loading = true;
      let query = { q: [] };

      query = {
        q: [
          {
            name: "marcacoes.show",
            id: "marcacao",
            parms: {
              id: this.$props.id,
              pre_atendimento: true,
              buscar_outras: true, 
              id_fila_laudo: this.fila, 
            }
          },
        ]
      };

      if ( this.fila && !this.panel ) { 
        query.q.push({
          name: "fila_laudos.show",
          id: "fila",
          parms: { id: this.fila }
        });
      }

      this.axios
        .post("/aql?a=pep.load", query)
        .then(res => {
          this.marcacao = res.data.marcacao.data;
          this.paciente = res.data.marcacao.data.paciente;
          this.legado = null;
          this.resultados = null;

          if (!this.panel) {

            let titulo = 'Pré-Atendimento: ' + this.paciente.st_nome;

            if ( res.data.fila.data ) { 
              this.titulo_fila = res.data.fila.data.search;

              titulo = this.titulo_fila + ': ' + this.paciente.st_nome;
            }

            this.$store.commit("setBreadcrumb", [
              { name: "Assistência", path: "/assistencia/atend" },
              { name: titulo, path: this.$route.path }
            ]);
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
          this.loading = false;
        });
    },
    load_detail(atendimento) {
      this.$store.commit("loading", true);
      let query = {
        q: [
          {
            name: "atendimentos.show",
            id  : "item",
            parms: { id: atendimento.id_atendimento }
          }
        ]
      };
      this.axios
        .post("/aql", query)
        .then(res => {
          this.atendimento = res.data.item.data;
          $("#detailModal").modal("show");
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });
    },
    getHumanDay(date) {
      return moment(date, "YYYY-MM-DD").format("dddd");
    },
    getHumanDate(date) {
      return (
        moment(date, "YYYY-MM-DD").format("DD") +
        " de " +
        moment(date, "YYYY-MM-DD").format("MMMM") +
        (moment(date, "YYYY-MM-DD").format("YYYY") == new Date().getFullYear()
          ? ""
          : " de " + moment(date, "YYYY-MM-DD").format("YYYY"))
      );
    },
    getHumanDuration(date) {
      if (date.substr(0, 10) == this.$util.hoje()) return "hoje";
      else
        return moment
          .duration(moment(date, "YYYY-MM-DD").diff(this.$util.hoje()))
          .humanize(true);
    },
    sexo(sexo) {
      return sexo == "M" ? "Masculino" : sexo == "F" ? "Feminino" : "";
    },
    idade(date) {
      return moment.duration(moment(date, "YYYY-MM-DD").diff()).humanize();
    },
    telefone(telefone) {
      let textoAjustado = "(" + telefone.st_numero.slice(0, 2) + ") ";
      if (telefone.ch_tipo_telefone == "M") {
        const parte1 = telefone.st_numero.slice(2, 7);
        const parte2 = telefone.st_numero.slice(7, 11);
        textoAjustado = textoAjustado + `${parte1}-${parte2}`;
      } else {
        const parte1 = telefone.st_numero.slice(2, 6);
        const parte2 = telefone.st_numero.slice(6, 10);
        textoAjustado = textoAjustado + `${parte1}-${parte2}`;
      }

      return textoAjustado;
    }
    // printAnamnese(dadosFormulario_) {
    //   let dadosFormulario = dadosFormulario_;
    //   this.$refs.impressaoAnamense.imprimirAnamnese(
    //     this.atendimento,
    //     dadosFormulario
    //   );
    // }
  },
  mounted() {
    this.tamanho = this.$util.getCookie('tamanho-fonte-pep') ? this.$util.getCookie('tamanho-fonte-pep') : 'M';

    this.$store.commit("setBreadcrumb", [
        { name: "Assistência", path: "/assistencia/atend" },
        { name: "Carregando...", path: this.$route.path }
    ]);

    this.local = this.$util.getCookie('local-chamada');
    this.expandido = this.$util.getCookie('pep-comprimido') == 'true' ? false : true ;

    this.listMode = this.$util.getCookie(this.cookie_list_mode) ? this.$util.getCookie(this.cookie_list_mode) : 'L';

    this.load();
  },
  updated() {
    $('[data-toggle="tooltip"]').tooltip();
  }
};
</script>

<style scoped>
.sidebar {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}

.timeline {
  list-style: none;
  padding: 20px 0 20px;
  position: relative;
}
.timeline:before {
  top: 0;
  bottom: 0;
  position: absolute;
  content: " ";
  width: 3px;
  background-color: #eeeeee;
  left: 50%;
  margin-left: -1.5px;
}
.timeline > li {
  margin-bottom: 20px;
  position: relative;
  width: 50%;
  float: left;
  clear: left;
}
.timeline > li:before,
.timeline > li:after {
  content: " ";
  display: table;
}
.timeline > li:after {
  clear: both;
}
.timeline > li:before,
.timeline > li:after {
  content: " ";
  display: table;
}
.timeline > li:after {
  clear: both;
}
.timeline > li > .timeline-panel {
  width: 95%;
  float: left;
  border: 1px solid #d4d4d4;
  /*border-radius: 2px;*/
  /*padding: 20px;*/
  position: relative;
  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);
}

.timeline > li > .timeline-panel:before {
  position: absolute;
  top: 26px;
  right: -15px;
  display: inline-block;
  border-top: 15px solid transparent;
  border-left: 15px solid #ccc;
  border-right: 0 solid #ccc;
  border-bottom: 15px solid transparent;
  content: " ";
}
.timeline > li > .timeline-panel:after {
  position: absolute;
  top: 27px;
  right: -14px;
  display: inline-block;
  border-top: 14px solid transparent;
  border-left: 14px solid #fff;
  border-right: 0 solid #fff;
  border-bottom: 14px solid transparent;
  content: " ";
}
.timeline > li > .timeline-badge {
  color: #fff;
  width: 24px;
  height: 24px;
  line-height: 50px;
  font-size: 1.4em;
  text-align: center;
  position: absolute;
  top: 16px;
  right: -12px;
  /*background-color: #999999;*/
  z-index: 100;
  /*
  border-top-right-radius: 50%;
  border-top-left-radius: 50%;
  border-bottom-right-radius: 50%;
  border-bottom-left-radius: 50%;
  */
}
.timeline > li.timeline-inverted > .timeline-panel {
  float: right;
}
.timeline > li.timeline-inverted > .timeline-panel:before {
  border-left-width: 0;
  border-right-width: 15px;
  left: -15px;
  right: auto;
}
.timeline > li.timeline-inverted > .timeline-panel:after {
  border-left-width: 0;
  border-right-width: 14px;
  left: -14px;
  right: auto;
}
.timeline-badge > a {
  color: #c5c7c5 !important;
}
.timeline-badge a:hover {
  color: #000 !important;
}
.timeline-title {
  margin-top: 0;
  color: inherit;
}
.timeline-body > p,
.timeline-body > ul {
  padding: 20px;
  margin-bottom: 0;
}
.timeline-body > p + p {
  margin-top: 5px;
}
.timeline-footer {
  padding: 20px;
  background-color: #f4f4f4;
}
.timeline-footer > a {
  cursor: pointer;
  text-decoration: none;
}
.tooltip {
  position: absolute;
  z-index: 1020;
  display: block;
  visibility: visible;
  padding: 5px;
  font-size: 11px;
  opacity: 0;
  filter: alpha(opacity=0);
}
.tooltip.in {
  /*opacity:0;
    filter:alpha(opacity=80);*/
}
.tooltip.top {
  margin-top: -2px;
}
.tooltip.right {
  margin-left: 2px;
}
.tooltip.bottom {
  margin-top: 2px;
}
.tooltip.left {
  margin-left: -2px;
}
.tooltip.top .tooltip-arrow {
  bottom: 0;
  left: 0;
  margin-left: 0;
  border-left: 0 solid transparent;
  border-right: 5px solid transparent;
  border-top: 0 solid #000;
}
.tooltip.left .tooltip-arrow {
  bottom: 0;
  left: 0;
  margin-left: 0;
  border-left: 0 solid transparent;
  border-right: 5px solid transparent;
  border-top: 0 solid #000;
}
.tooltip.bottom .tooltip-arrow {
  bottom: 0;
  left: 0;
  margin-left: 0;
  border-left: 0 solid transparent;
  border-right: 5px solid transparent;
  border-top: 0 solid #000;
}
.tooltip.right .tooltip-arrow {
  bottom: 0;
  left: 0;
  margin-left: 0;
  border-left: 0 solid transparent;
  border-right: 5px solid transparent;
  border-top: 0 solid #000;
}
.tooltip-inner {
  width: 200px;
  padding: 3px 8px;
  color: #fff;
  text-align: center;
  text-decoration: none;
  background-color: #313131;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  border-radius: 0px;
}
.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
}
.timeline > li.timeline-inverted {
  float: right;
  clear: right;
  margin-top: 30px;
  margin-bottom: 30px;
}
.timeline > li:nth-child(2) {
  margin-top: 60px;
}
.timeline > li.timeline-inverted > .timeline-badge {
  left: -12px;
}

@media (max-width: 767px) {
  ul.timeline:before {
    left: 40px;
  }

  ul.timeline > li {
    margin-bottom: 20px;
    position: relative;
    width: 100%;
    float: left;
    clear: left;
  }
  ul.timeline > li > .timeline-panel {
    width: calc(100% - 90px);
    width: -moz-calc(100% - 90px);
    width: -webkit-calc(100% - 90px);
  }

  ul.timeline > li > .timeline-badge {
    left: 28px;
    margin-left: 0;
    top: 16px;
  }

  ul.timeline > li > .timeline-panel {
    float: right;
  }

  ul.timeline > li > .timeline-panel:before {
    border-left-width: 0;
    border-right-width: 15px;
    left: -15px;
    right: auto;
  }

  ul.timeline > li > .timeline-panel:after {
    border-left-width: 0;
    border-right-width: 14px;
    left: -14px;
    right: auto;
  }

  .timeline > li.timeline-inverted {
    float: left;
    clear: left;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .timeline > li.timeline-inverted > .timeline-badge {
    left: 28px;
  }
}
</style>

